import { Transition } from "@uirouter/core";
import { BaseToolbarController } from "application/baseProduct.toolbar.controller";
import IBaseViewParams from "infrastructure/interfaces/IBaseViewParams";

const PrintOptions = [
    "policy",
    "policyWithoutA7",
    "emptyPolicy",
    "worksheet",
    "paymentAccountAll",
    "freeFormReceipt",
];

export class SnugHomeToolbarController extends BaseToolbarController {
    constructor(
        $injector: angular.auto.IInjectorService,
        $transition: Transition,
        {
            viewType = "form",
            printOptions = PrintOptions,
        }: IBaseViewParams,
    ) {
        super($injector, $transition, {
            viewType,
            printOptions,
            crossOptions: [
                "uAuto",
                "osago",
                "snugHome",
                "express",
                "myChoice",
                "constructorHome",
                "assuranceApartment",
                "assuranceHome",
            ],
            extraOptions: [
                "manual",
                "integrationInfo",
                "annul",
            ],
        });
    }
}
